import { motion, MotionProps, Transition } from 'framer-motion'
import { twMerge } from 'tailwind-merge'
import useMeasure from 'react-use-measure'

type ResizableDivProps = React.ComponentProps<'div'> &
  MotionProps & {
    parentClassName?: string
    containerClassName?: string
    animateWidth?: boolean
    animateHeight?: boolean
  }

function ResizableDiv({
  children,
  className,
  containerClassName,
  animateWidth = true,
  animateHeight = true,
  ...props
}: ResizableDivProps) {
  const [ref, bounds] = useMeasure()

  const transition: Transition = {
    type: 'spring' as const,
    stiffness: 550,
    damping: 45,
    mass: 0.7,
  }

  // If both animations disabled, render plain div for performance
  if (!animateWidth && !animateHeight) {
    return (
      <div className={twMerge('relative overflow-hidden', className)} {...(props as React.ComponentProps<'div'>)}>
        <div ref={ref} className={twMerge('w-fit', containerClassName)}>
          {children}
        </div>
      </div>
    )
  }

  return (
    <motion.div
      animate={{
        width: animateWidth ? (bounds.width > 0 ? bounds.width : 'auto') : undefined,
        height: animateHeight ? (bounds.height > 0 ? bounds.height : 'auto') : undefined,
      }}
      transition={transition}
      className={twMerge('relative overflow-hidden', className)}
      {...props}
    >
      <div ref={ref} className={twMerge('w-fit', containerClassName)}>
        {children}
      </div>
    </motion.div>
  )
}

export { ResizableDiv }
